import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as cursorUsageEvents from '../../cursor-usage-events'

export const RESOURCE = {
  payload: {
    description: 'One call to Cursor, captured at the moment it happened.',
    dimension: cursorUsageEvents.RESOURCE.payload,
    level: 0,
    name: 'Cursor Usage Event',
    partialId: PartialId.Standard.create('cursor_usage_event'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
